import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    info: {
        id: '_.apply_flexi_loan.newDocUploads.truelayer.info',
        defaultMessage:
            "We're registered with the {FCALink} for the provision of payment services, which allows us to offer Open Banking. {link}"
    },
    infoLink: {
        id: '_.apply_flexi_loan.newDocUploads.truelayer.info_link',
        defaultMessage: 'https://www.openbanking.org.uk/what-is-open-banking/'
    },
    infoLinkText: {
        id: '_.apply_flexi_loan.newDocUploads.truelayer.info_link_text',
        defaultMessage: 'Learn more'
    },
    FCALink: {
        id: '_.apply_flexi_loan.newDocUploads.truelayer.fca_link',
        defaultMessage:
            'https://register.fca.org.uk/s/firm?id=001b00000413NAxAAM'
    },
    FCALinkText: {
        id: '_.apply_flexi_loan.newDocUploads.truelayer.fca_link_text',
        defaultMessage: 'FCA'
    },
    infoTwo: {
        id: '_.apply_flexi_loan.newDocUploads.truelayer.info_two',
        defaultMessage:
            'Your transactions must cover the stated period and be from the account(s) where the majority of your business revenue is generated.'
    },
    linkCTA: {
        id: '_.apply_flexi_loan.newDocUploads.truelayer.link_cta',
        defaultMessage: 'Link bank account'
    }
});
